import { useAvelaToast } from "src/hooks/useAvelaToast";
import { maybePluralize } from "src/services/format";
import * as AF from "src/types/formTemplate";
import { Action } from "./reducer";
import * as S from "./types/state";

export function useCheckPendingQuestionEdits(
  state: S.State,
  dispatch: (action: Action) => void
) {
  const toast = useAvelaToast();

  const checkPendingQuestionEdits = (): {
    success: boolean;
    validations: AF.V2.ValidationResult[];
  } => {
    const validations: AF.V2.ValidationResult[] = [];
    state.get("questionModes").forEach((mode, questionId) => {
      if (mode === "Edit") {
        validations.push({
          id: questionId,
          error:
            "This question is being edited... Please update or cancel the changes.",
          level: "Question",
        });
      }
    });
    const success = validations.length === 0;

    if (!success) {
      dispatch({
        type: "SetValidations",
        validations,
      });
      toast.error({
        title: `${validations.length} ${maybePluralize(
          validations.length,
          "error",
          "errors"
        )} found`,
        description: "",
        duration: null,
      });
    }

    return { success, validations };
  };

  return { checkPendingQuestionEdits };
}
